"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapScenarios = void 0;
const MapExecutor_1 = require("./MapExecutor");
const Nodes_1 = require("./Nodes");
const lodash_1 = __importDefault(require("lodash"));
//Internal nodes, are nodes that should never appear in the tool palette, like FormError, FormWarning, etc.
const internalNodes = [
    'FORM-ERROR',
    'FORM-WARNING',
    'DISPLAY-OPTIONS',
    'FORM-CONDITIONAL',
    'OBJECT-BUILDER',
    'BUTTON-STATE',
    'OUTPUT-EVENT',
    'ARRAY-ITERATOR',
    'DROPDOWN-OPTIONS',
];
//These are nodes that represent available inputs and arent' applicable in all scenarios
const inputNodes = [
    'EVENT',
    'METADATA',
    'STATE',
    'FORM',
    'FORMVALUE',
    'DATA',
    'COMMAND_DATA',
];
//These are all nodes that should be available for the user to create in most maps
const userCreateableNodes = Object.keys(Nodes_1.AllNodeMap).filter((nodeType) => !internalNodes.includes(nodeType) && !inputNodes.includes(nodeType));
const asyncEvaluator = (map, accessors, configFunctions, timestamp, parentNodeId) => {
    return (0, MapExecutor_1.asynchronousMapDataToObject)(map, accessors, configFunctions, timestamp, parentNodeId).then(result => {
        return result;
    });
};
//TODO: Can't really make this better defined at the moment. Need more tricks
exports.mapScenarios = {
    EVENT_AGGREGATE_MAP: {
        availableNodes: [...userCreateableNodes, 'EVENT', 'STATE'],
        defaultNodeMap: {
            nodes: {
                EVENT: { type: 'EVENT', name: 'Event', inputs: {} },
                STATE: { type: 'STATE', name: 'Current State', inputs: {} },
                OUTPUT: { type: 'OBJECT-BUILDER', name: 'Output State', inputs: {}, config: { objectSchema: 'STATE' } },
            },
            outputDefinition: {
                outputNode: 'OUTPUT',
            },
        },
        requiredNodes: [{ nodeId: 'OUTPUT', nodeType: 'OBJECT-BUILDER' }],
        evaluate: asyncEvaluator,
    },
    DERIVED_PROPERTY_MAPPING: {
        availableNodes: [...userCreateableNodes, 'STATE'],
        defaultNodeMap: {
            nodes: {
                STATE: { type: 'STATE', name: 'Current State', inputs: {} },
                OUTPUT: { type: 'OBJECT-BUILDER', name: 'Output State', inputs: {}, config: { objectSchema: 'STATE' } },
            },
            outputDefinition: {
                outputNode: 'OUTPUT',
            },
        },
        requiredNodes: [{ nodeId: 'OUTPUT', nodeType: 'OBJECT-BUILDER' }],
        evaluate: asyncEvaluator,
    },
    INITIAL_DATA_MAPPING: {
        availableNodes: [...userCreateableNodes, 'STATE', 'METADATA'],
        defaultNodeMap: {
            nodes: {
                STATE: { type: 'STATE', name: 'Current State', inputs: {} },
                OUTPUT: { type: 'OBJECT-BUILDER', name: 'Form State', inputs: {}, config: { objectSchema: 'FORM' } },
            },
            outputDefinition: {
                outputNode: 'OUTPUT',
            },
        },
        requiredNodes: [{ nodeId: 'OUTPUT', nodeType: 'OBJECT-BUILDER' }],
        evaluate: asyncEvaluator,
    },
    COMPUTED_MAPPING: {
        availableNodes: [...userCreateableNodes, 'FORM', 'STATE', 'METADATA', 'FORMVALUE'],
        defaultNodeMap: {
            nodes: {
                FORM: { type: 'FORM', name: 'Form', inputs: {} },
                FORMVALUE: { type: 'FORMVALUE', name: 'Value', inputs: {} },
                OUTPUT: { type: 'OBJECT-BUILDER', name: 'Result', inputs: {}, config: { objectSchema: 'COMPUTED' } },
            },
            outputDefinition: {
                outputNode: 'OUTPUT',
            },
        },
        requiredNodes: [{ nodeId: 'OUTPUT', nodeType: 'OBJECT-BUILDER' }],
        evaluate: asyncEvaluator,
    },
    COMMAND_EVENT_MAPPING: {
        availableNodes: [...userCreateableNodes, 'DATA', 'METADATA', 'COMMAND_DATA'],
        defaultNodeMap: {
            nodes: {
                COMMAND: { type: 'DATA', name: 'Command' },
                OUTPUT: { type: 'OBJECT-BUILDER', name: 'Event', inputs: {}, config: { objectSchema: 'EVENT' } },
            },
            outputDefinition: {
                outputNode: 'OUTPUT',
            },
        },
        requiredNodes: [{ nodeId: 'OUTPUT', nodeType: 'OBJECT-BUILDER' }],
        evaluate: asyncEvaluator,
    },
    FUNCTION_MAPPING: {
        availableNodes: [...lodash_1.default.without(userCreateableNodes, 'FUNCTION'), 'DATA'],
        defaultNodeMap: {
            nodes: {
                COMMAND: { type: 'DATA', name: 'Input' },
                OUTPUT: { type: 'OBJECT-BUILDER', name: 'Output', inputs: {}, config: { objectSchema: 'STATE' } },
            },
            outputDefinition: {
                outputNode: 'OUTPUT',
            },
        },
        requiredNodes: [{ nodeId: 'OUTPUT', nodeType: 'OBJECT-BUILDER' }],
        evaluate: asyncEvaluator,
    },
    COMMAND_MULTI_EVENT_MAPPING: {
        availableNodes: [...userCreateableNodes, 'DATA', 'METADATA', 'OUTPUT-EVENT', 'ARRAY-ITERATOR', 'COMMAND_DATA'],
        defaultNodeMap: {
            nodes: {
                COMMAND: { type: 'DATA', name: 'Command' },
                OUTPUT: { type: 'OUTPUT-EVENT', name: 'Output Event', inputs: {}, config: { objectSchema: 'EVENT' } },
            },
            outputDefinition: {
                outputQuery: {
                    types: ['OUTPUT-EVENT'],
                },
            },
        },
        requiredNodes: [{ nodeId: 'OUTPUT', nodeType: 'OBJECT-BUILDER' }],
        evaluate: (map, accessors, configFunctions, timestamp, parentNodeId) => {
            return (0, MapExecutor_1.asynchronousMapDataToObject)(map, accessors, configFunctions, timestamp, parentNodeId).then(result => 
            //Filters out any null values returned
            Object.values(result).filter(val => !!val));
        },
    },
    FORM_LEVEL_ERROR: {
        availableNodes: [...userCreateableNodes, 'FORM', 'STATE', 'METADATA'],
        defaultNodeMap: {
            nodes: {
                FORM: { type: 'FORM', name: 'Form', inputs: {} },
                FORM_ERROR: { type: 'FORM-ERROR', inputs: {} },
            },
            outputDefinition: {
                outputNode: 'FORM_ERROR',
            },
        },
        requiredNodes: [{ nodeId: 'FORM_ERROR', nodeType: 'FORM-ERROR' }],
        evaluate: asyncEvaluator,
    },
    FORM_FIELD_CONDITIONAL: {
        availableNodes: [...userCreateableNodes, 'FORM', 'STATE', 'METADATA', 'FORMVALUE'],
        defaultNodeMap: {
            nodes: {
                FORM: { type: 'FORM', name: 'Form', inputs: {} },
                FORMVALUE: { type: 'FORMVALUE', name: 'Value', inputs: {} },
                FORM_CONDITIONAL: { type: 'FORM-CONDITIONAL', inputs: {} },
            },
            outputDefinition: {
                outputNode: 'FORM_CONDITIONAL',
            },
        },
        requiredNodes: [{ nodeId: 'FORM_CONDITIONAL', nodeType: 'FORM-CONDITIONAL' }],
        evaluate: asyncEvaluator,
    },
    FORM_LEVEL_WARNING: {
        availableNodes: [...userCreateableNodes, 'FORM', 'STATE', 'METADATA'],
        defaultNodeMap: {
            nodes: {
                FORM: { type: 'FORM', name: 'Form', inputs: {} },
                FORM_WARNING: { type: 'FORM-WARNING', inputs: {} },
            },
            outputDefinition: {
                outputNode: 'FORM_WARNING',
            },
        },
        requiredNodes: [{ nodeId: 'FORM_WARNING', nodeType: 'FORM-WARNING' }],
        evaluate: asyncEvaluator,
    },
    FIELD_LEVEL_ERROR: {
        availableNodes: [...userCreateableNodes, 'FORM', 'STATE', 'METADATA', 'FORMVALUE'],
        defaultNodeMap: {
            nodes: {
                FORM: { type: 'FORM', name: 'Form', inputs: {} },
                FORMVALUE: { type: 'FORMVALUE', name: 'Value', inputs: {} },
                FIELD_ERROR: { type: 'FORM-ERROR', name: 'Field Error' },
            },
            outputDefinition: {
                outputNode: 'FIELD_ERROR',
            },
        },
        requiredNodes: [{ nodeId: 'FIELD_ERROR', nodeType: 'FORM-ERROR' }],
        evaluate: asyncEvaluator,
    },
    FIELD_LEVEL_WARNING: {
        availableNodes: [...userCreateableNodes, 'FORM', 'STATE', 'METADATA', 'FORMVALUE'],
        defaultNodeMap: {
            nodes: {
                FORM: { type: 'FORM', name: 'Form', inputs: {} },
                FORMVALUE: { type: 'FORMVALUE', name: 'Value', inputs: {} },
                FIELD_WARNING: { type: 'FORM-WARNING', name: 'Field Warning' },
            },
            outputDefinition: {
                outputNode: 'FIELD_WARNING',
            },
        },
        requiredNodes: [{ nodeId: 'FIELD_WARNING', nodeType: 'FORM-WARNING' }],
        evaluate: asyncEvaluator,
    },
    DISPLAY_OPTIONS: {
        availableNodes: [...userCreateableNodes, 'FORM', 'STATE', 'METADATA', 'FORMVALUE'],
        defaultNodeMap: {
            nodes: {
                FORM: { type: 'FORM', name: 'Form', inputs: {} },
                FORMVALUE: { type: 'FORMVALUE', name: 'Value', inputs: {} },
                DISPLAY_OPTIONS: { type: 'DISPLAY-OPTIONS', name: 'Display Options' },
            },
            outputDefinition: {
                outputNode: 'DISPLAY_OPTIONS',
            },
        },
        requiredNodes: [{ nodeId: 'DISPLAY_OPTIONS', nodeType: 'DISPLAY-OPTIONS' }],
        evaluate: asyncEvaluator,
    },
    DROPDOWN_OPTIONS: {
        availableNodes: [...userCreateableNodes, 'FORM', 'STATE', 'METADATA', 'FORMVALUE'],
        defaultNodeMap: {
            nodes: {
                FORM: { type: 'FORM', name: 'Form', inputs: {} },
                FORMVALUE: { type: 'FORMVALUE', name: 'Value', inputs: {} },
                DROPDOWN_OPTIONS: { type: 'DROPDOWN-OPTIONS', name: 'Options' },
            },
            outputDefinition: {
                outputNode: 'DROPDOWN_OPTIONS',
            },
        },
        requiredNodes: [{ nodeId: 'DROPDOWN_OPTIONS', nodeType: 'DROPDOWN-OPTIONS' }],
        evaluate: asyncEvaluator,
    },
    BUTTON_STATE: {
        availableNodes: [...userCreateableNodes, 'STATE', 'METADATA'],
        defaultNodeMap: {
            nodes: {
                STATE: { type: 'STATE' },
                BUTTON_STATE: { type: 'BUTTON-STATE', name: 'Button State' },
            },
            outputDefinition: {
                outputNode: 'BUTTON_STATE',
            },
        },
        requiredNodes: [{ nodeId: 'BUTTON_STATE', nodeType: 'BUTTON-STATE' }],
        evaluate: asyncEvaluator,
    },
    FAB_BUTTON_STATE: {
        availableNodes: [...userCreateableNodes, 'METADATA'],
        defaultNodeMap: {
            nodes: {
                METADATA: { type: 'METADATA' },
                BUTTON_STATE: { type: 'BUTTON-STATE', name: 'Button State' },
            },
            outputDefinition: {
                outputNode: 'BUTTON_STATE',
            },
        },
        requiredNodes: [{ nodeId: 'BUTTON_STATE', nodeType: 'BUTTON-STATE' }],
        evaluate: asyncEvaluator,
    },
    CARD_ELEMENT_MAP: {
        availableNodes: [...userCreateableNodes, 'STATE', 'METADATA'],
        defaultNodeMap: {
            nodes: {
                STATE: { type: 'STATE', name: 'Current State', inputs: {} },
                OUTPUT: { type: 'OBJECT-BUILDER', name: 'Output', inputs: {}, config: { objectSchema: 'FORM' } },
            },
            outputDefinition: {
                outputNode: 'OUTPUT',
            },
        },
        requiredNodes: [{ nodeId: 'OUTPUT', nodeType: 'OBJECT-BUILDER' }],
        evaluate: asyncEvaluator,
    },
    NAVIGATION_OPTIONS: {
        availableNodes: [...userCreateableNodes, 'STATE', 'METADATA'],
        defaultNodeMap: {
            nodes: {
                STATE: { type: 'STATE' },
                NAVIGATION_OPTIONS: { type: 'NAVIGATION-OPTIONS', name: 'Navigation Options' },
            },
            outputDefinition: {
                outputNode: 'NAVIGATION_OPTIONS',
            },
        },
        requiredNodes: [{ nodeId: 'NAVIGATION_OPTIONS', nodeType: 'NAVIGATION-OPTIONS' }],
        evaluate: asyncEvaluator,
    },
};
/*const MapAsyncScenarioExecutor = async (
  mapDefinition: NodeMapDefinition,
  accessors?: AccessorMap
): Promise<Record<string, unknown>> => {};
*/
//# sourceMappingURL=MapScenarios.js.map